import { render } from "./Borrower.vue?vue&type=template&id=51f89570"
import script from "./Borrower.vue?vue&type=script&lang=js"
export * from "./Borrower.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__